module.exports = __webpack_public_path__ + "static/img/nav-4.ad2a4620.svg";